import { httpRequest } from '@/services/httpClient'

export type Department = {
  departmentId: number
  tenantId?: number
  name: string
  code?: string | null
  description?: string | null
  organizationId?: number | null
  parentId?: number | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  lastUpdated: string
}

export type DepartmentsListResponse = {
  items: Department[]
  totalCount: number
  page: number
  pageSize: number
}

export type DepartmentsListParams = {
  tenantId?: number
  organizationId?: number | null
  search?: string
  isActive?: boolean | null
  includeDeleted?: boolean
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name' | 'lastUpdated'
  sortDir?: 'asc' | 'desc'
}

export type CreateDepartmentPayload = {
  tenantId?: number
  code?: string | null
  name: string
  description?: string | null
  organizationId?: number | null
  parentId?: number | null
  isActive?: boolean
}

export type UpdateDepartmentPayload = CreateDepartmentPayload & {
  id: number
}

export type CreateUpdateResponse = {
  success: boolean
  data?: {
    id: number
    name: string
    code?: string | null
  }
  message?: string
}

export const departmentsApi = {
  list: (params: DepartmentsListParams) =>
    httpRequest<DepartmentsListResponse>('/v1/departments', {
      method: 'GET',
      query: {
        tenantId: params.tenantId,
        organizationId: params.organizationId ?? undefined,
        search: params.search?.trim() ? params.search.trim() : undefined,
        isActive: params.isActive === null ? undefined : params.isActive,
        includeDeleted: params.includeDeleted,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) => httpRequest<Department>(`/v1/departments/${id}`, { method: 'GET' }),

  create: (payload: CreateDepartmentPayload) =>
    httpRequest<CreateUpdateResponse>('/v1/departments', {
      method: 'POST',
      body: payload,
    }),

  update: (payload: UpdateDepartmentPayload) =>
    httpRequest<CreateUpdateResponse>(`/v1/departments/${payload.id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<{ success: boolean; message?: string }>(`/v1/departments/${id}`, {
      method: 'DELETE',
    }),
}
